"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
/**
 * Describes a BPMN Message, which can be sent/received by MessageEvents.
 */
class Message {
}
exports.Message = Message;
//# sourceMappingURL=Message.js.map